"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toCamelCase = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _camelcase = _interopRequireDefault(require("camelcase"));
var _mapObj = _interopRequireDefault(require("map-obj"));
var camelCaseConvert = function camelCaseConvert(input) {
  return (0, _mapObj.default)(input, function (key, val) {
    return [(0, _camelcase.default)(key), val];
  }, {
    deep: true
  });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var toCamelCase = function toCamelCase(input) {
  if (!input) return undefined;
  if (Array.isArray(input)) {
    return input.map(camelCaseConvert);
  }
  if ((0, _typeof2.default)(input) === 'object') {
    return camelCaseConvert(input);
  }
  return input;
};
exports.toCamelCase = toCamelCase;